






















































import { Getter, Mutation, State } from 'vuex-class';
import { Component, Vue } from 'vue-property-decorator';
import WelcomeBanner from '~/components/Home/WelcomeBanner.vue';
import ItemList from '~/components/Games/Items/ItemList.vue';
import GameCarousel from '~/components/Games/GameCarousel.vue';
import PromoBanner from '~/components/Promotions/PromoBanner.vue';
import SuperiorPromotion from '~/components/Promotions/SuperiorPromotion.vue';
import TWDPromotion from '~/components/Promotions/TWDPromotion.vue';
import TokenMigrationAlert from '~/components/Promotions/TokenMigrationAlert.vue';
import MediumNewsFeed from '~/components/Home/MediumNewsFeed.vue';
import InteractiveBanner from '~/components/Home/InteractiveBanner.vue';
import EmailVerifiedConfirmation from '~/components/EmailVerification/EmailVerifiedConfirmation.vue';
import hotStoreItems from '~/queries/hotStoreItems.gql';
import { IGameItemForSaleByGala, IGame } from '~/store/games/types';
import { ICurrentPage } from '~/store/types';
import { IUser } from '~/store/profile/types';
import { filterList } from '~/utils/listFilters';
import { IBanner } from '~/types/banner';
import HomepageTakeover from '~/components/Home/HomepageTakeoverHeroBanner.vue';
import { showHomepageTakeover } from '~/data/timed_events';

@Component({
  components: {
    ItemList,
    GameCarousel,
    WelcomeBanner,
    MediumNewsFeed,
    InteractiveBanner,
    EmailVerifiedConfirmation,
    PromoBanner,
    TWDPromotion,
    TokenMigrationAlert,
    SuperiorPromotion,
    HomepageTakeover,
  },
})
export default class Home extends Vue {
  @State(games => games.games, { namespace: 'games' })
  games!: IGame[];
  @State(profile => profile.user, { namespace: 'profile' })
  currentUser!: IUser;
  @State(profile => profile.user.goldMember, { namespace: 'profile' })
  readonly goldMember!: boolean;
  @State(profile => profile.user.galaPower, { namespace: 'profile' })
  readonly galaPower!: number;
  @State(shareState => shareState.founderNodesOwned, { namespace: 'share' })
  readonly founderNodesOwned!: number;
  @Getter('mainBanner', { namespace: 'cmsContent' })
  readonly mainBanner!: IBanner;
  @State(cmsContent => cmsContent.homepageTakeover, {
    namespace: 'cmsContent',
  })
  hpto!: any;

  @Mutation updateCurrentPage!: (payload: ICurrentPage) => void;

  fetchingItemsForSale = false;
  showEmailVerifiedConfirmation = false;
  unfilteredRecentDrops: IGameItemForSaleByGala[] = [];
  unfilteredTopItems: IGameItemForSaleByGala[] = [];

  get showHomepageTakeover() {
    return this.hpto !== null;
  }

  get recentDrops() {
    if (!this.goldMember && !this.founderNodesOwned) {
      return filterList('userNotGoldOrNodeOwner', this.unfilteredRecentDrops, {
        galaPower: this.galaPower,
      });
    } else if (!this.goldMember) {
      return filterList('goldMember', this.unfilteredRecentDrops, {
        galaPower: this.galaPower,
      });
    } else if (!this.founderNodesOwned) {
      return filterList('userNotNodeOwner', this.unfilteredRecentDrops, {
        galaPower: this.galaPower,
      });
    } else {
      return filterList('galaPower', this.unfilteredRecentDrops, {
        galaPower: this.galaPower,
      });
    }
  }

  get topItems() {
    if (!this.goldMember && !this.founderNodesOwned) {
      return filterList('userNotGoldOrNodeOwner', this.unfilteredTopItems, {
        galaPower: this.galaPower,
      });
    } else if (!this.goldMember) {
      return filterList('goldMember', this.unfilteredTopItems, {
        galaPower: this.galaPower,
      });
    } else if (!this.founderNodesOwned) {
      return filterList('userNotNodeOwner', this.unfilteredTopItems, {
        galaPower: this.galaPower,
      });
    } else {
      return filterList('galaPower', this.unfilteredTopItems, {
        galaPower: this.galaPower,
      });
    }
  }

  async created() {
    this.updateCurrentPage({ title: '' });
    this.handleEmailVerificationModals();
    try {
      this.fetchingItemsForSale = true;
      await this.fetchBatchedStoreItems();
      this.fetchingItemsForSale = false;
    } catch (error) {
      this.$sentry.captureException(error);
      console.log(error);
      this.fetchingItemsForSale = false;
    }
  }

  async fetchBatchedStoreItems() {
    const recentDropsInput = {
      currency: 'GALA',
      limit: 6,
      numberFilterOptions: [
        {
          field: 'supply.currentSupply',
          value: 0,
          comparator: 'gt',
        },
      ],
      sortOptions: {
        sortField: 'dateAvailable',
        sortDirection: -1,
      },
    };

    const topSellersInput = {
      currency: 'GALA',
      limit: 6,
      numberFilterOptions: [
        {
          field: 'supply.currentSupply',
          value: 0,
          comparator: 'gt',
        },
      ],
      stringFilterOptions: [
        {
          field: 'category',
          value: 'CraneBot',
          comparator: 'ne',
        },
      ],
      sortOptions: {
        sortField: 'orderCount',
        sortDirection: -1,
      },
    };
    const { data } = (await this.$apollo.query({
      query: hotStoreItems,
      variables: {
        recentDropsInput,
        topSellersInput,
      },
      fetchPolicy: 'no-cache',
    })) as any;

    if (data && data.recentDrops && data.topSellers) {
      this.unfilteredRecentDrops = data.recentDrops;
      this.unfilteredTopItems = data.topSellers;
    }
  }

  handleEmailVerificationModals() {
    const { emailVerified } = this.$route.query;
    if (emailVerified) {
      this.showEmailVerifiedConfirmation = true;
    }
  }

  goTo(route: string) {
    this.$router.push(route);
  }
}
